import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setTransactionValue } from 'bundles/apex/deals/form/store/deal/actions';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import { calculatesTransactionValue } from 'bundles/apex/deals/lease_terms/helpers';

export function TransactionValue({ deal, invalid, label, required, setTransactionValue }) {
  return (
    <ManagedFormGroup
      disabled={calculatesTransactionValue(deal)}
      hasError={invalid}
      label={label}
      required={required}
      type="currency"
      value={deal.transactionValue}
      onValueChange={setTransactionValue}
    />
  );
}

TransactionValue.propTypes = {
  ...propTypes,
  setTransactionValue: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setTransactionValue,
};

export default connect(null, mapDispatchToProps)(DealField(TransactionValue, 'transactionValue'));
